import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const analyticsStaticData = {
  menuTitle: MenuTitle.Analytics
};

export const Route = createFileRoute('/_private-routes/analytics')({
  staticData: analyticsStaticData
});
